import React from "react";

interface AddItemProps {
    class?: string;
    header: string;
    content: JSX.Element;
}

export default class AddItem extends React.Component <AddItemProps> {
    render() {
        return (
            <div className={this.props.class + " add-record"}>
                <div className="content">
                    <div className="header" data-testid="add-item-header">
                        {this.props.header}
                    </div>
                    {this.props.content}
                </div>
            </div>
        );
    }
}